'use strict';

import $ from 'jquery';
import config from '../../js/config';
import $global from '../../js/globalElements';
import ContactFormModal from '../ContactFormModal/ContactFormModal';

let engineerMessageInstance = null;

export function createEngineerMessageView($parent) {
  // Instance already exists
  if (engineerMessageInstance) {
    return;
  }

  // Required elements do not exist on the page
  if (!$parent.find('.js-message-engineer').length && !$parent.find('.js-fullAgentList').length) {
    return;
  }

  engineerMessageInstance = ContactFormModal.getInstance();

  $global.$body.on('click', '.js-message-engineer', function(e) {
    const $link = $(this),
      id = $link.data('agentUid') || '',
      name = $link.data('agentName') || '';
    e.preventDefault();
    engineerMessageInstance.open({
      endPoint: config.urls.engineerMessage,
      hiddenFields: { Id: id, EngineerName: name }
    });
  });
}



// WEBPACK FOOTER //
// ./assets/components/Engineer/EngineerMessageView.js